import styled from "styled-components";

export const StyledSelect = styled.div`
  .custom-creatable {
    &__control {
      cursor: pointer;
      border: none;
      border-radius: 0;
      background-color: transparent;
      border-bottom: 1px solid ${({theme}) => theme.input.borderColor};
      &:hover {
        border-color: ${({theme}) => theme.input.borderHoverColor};
        box-shadow: 0 1px 0 0 ${({theme}) => theme.input.borderHoverColor};
      }
    }
    &__control--is-focused {
      border-bottom: 1px solid ${({theme}) => theme.input.borderFocusColor};
      box-shadow: 0 1px 0 0 ${({theme}) => theme.input.borderFocusColor};
    }
    &__value-container {
      padding: 0;
      grid-template-columns: 100%;
    }
    &__indicator-separator {
      display: none;
    }
    &__dropdown-indicator {
      width: 20px;
      position: relative;
      &:before {
        content: '\\e935';
        color: ${({theme}) => theme.input.iconColor};
        font-size: 18px;
        font-family: 'cp-icons', serif;
        position: absolute;
        top: 0;
        left: 0;
      }
     svg {
        display: none;
      }
    }
    &__input-container {
      padding: 0;
    }
    &__input {
      height: 25px !important;
      min-width: 300px !important;
      z-index: 1 !important;
      color: ${({theme}) => theme.input.color} !important;
    }
    &__single-value {
      color: ${({theme}) => theme.input.color};
    }
    &__placeholder {
      color: ${({theme}) => theme.input.labelColor};
    }
    &__clear-indicator {
      color: ${({theme}) => theme.input.iconColor};
      &:hover {
        color: ${({theme}) => theme.input.borderHoverColor};
      }
    }
    &__menu {
      background-color: ${({theme}) => theme.menu.background};
      color: ${({theme}) => theme.menu.color};
      box-shadow: ${({theme}) => theme.filter.dropdownShadow};
    }
    &__option {
      cursor: pointer;
      background-color: transparent;
      color: ${({theme}) => theme.menu.color};
    }
    &__option--is-focused {
      background-color: ${({theme}) => theme.menu.hoverBackground};
    }
    &__option--is-selected {
      background-color: ${({theme}) => theme.surface.selected};
      color: ${({theme}) => theme.input.color};
    }
    &__menu-notice {
      color: ${({theme}) => theme.text.muted};
    }
  }
`;

export const StyledSelectLabel = styled.label`
  color: ${({theme}) => theme.input.selectLabelColor};
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  transform: translate(0, 1.5px) scale(0.75);
  transform-origin: top left;
`;